var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTemplateArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 77,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#template-arrow_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.84 62.475 19.503 40.9l-8.741 14.21-2.615-43.722 37.942 21.884-16.619 1.467 13.337 21.574-9.967 6.162Z",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31.99 63 .525.851.85-.526 9.968-6.161.85-.526-.525-.85-12.485-20.196 15.003-1.324 3.158-.279-2.746-1.583L8.647 10.522l-1.61-.928.112 1.853L9.764 55.17l.189 3.164 1.66-2.7 7.892-12.828L31.99 63Z",
  stroke: "#D8DCE2",
  strokeWidth: 2
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "template-arrow_svg__a",
  x: 0.929,
  y: 0.8,
  width: 64.65,
  height: 75.428,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2586_35340"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2586_35340",
  result: "shape"
})))));
export { SvgTemplateArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjYiIGhlaWdodD0iNzciIHZpZXdCb3g9IjAgMCA2NiA3NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF8yNTg2XzM1MzQwKSI+CjxwYXRoIGQ9Ik0zMi44Mzk5IDYyLjQ3NDhMMTkuNTAzIDQwLjkwMDNMMTAuNzYyIDU1LjExMDFMOC4xNDY5NyAxMS4zODc3TDQ2LjA4ODYgMzMuMjcxOUwyOS40NzAyIDM0LjczODhMNDIuODA3IDU2LjMxMzNMMzIuODM5OSA2Mi40NzQ4WiIgZmlsbD0iIzMzMzMzMyIvPgo8cGF0aCBkPSJNMzEuOTg5MyA2My4wMDA2TDMyLjUxNTEgNjMuODUxMkwzMy4zNjU3IDYzLjMyNTRMNDMuMzMyOSA1Ny4xNjM5TDQ0LjE4MzUgNTYuNjM4MUw0My42NTc2IDU1Ljc4NzVMMzEuMTczNSAzNS41OTI0TDQ2LjE3NjUgMzQuMjY4TDQ5LjMzMzkgMzMuOTg5M0w0Ni41ODgyIDMyLjQwNTdMOC42NDY2MSAxMC41MjE1TDcuMDM3ODggOS41OTM1N0w3LjE0ODc2IDExLjQ0NzRMOS43NjM3NCA1NS4xNjk4TDkuOTUyOTggNTguMzMzN0wxMS42MTM3IDU1LjYzNEwxOS41MDUxIDQyLjgwNTVMMzEuOTg5MyA2My4wMDA2WiIgc3Ryb2tlPSIjRDhEQ0UyIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9nPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9kXzI1ODZfMzUzNDAiIHg9IjAuOTI4NzExIiB5PSIwLjc5OTU2MSIgd2lkdGg9IjY0LjY1MDQiIGhlaWdodD0iNzUuNDI4IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIiByZXN1bHQ9ImhhcmRBbHBoYSIvPgo8ZmVPZmZzZXQgZHg9IjQiIGR5PSIyIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjQuNSIvPgo8ZmVDb21wb3NpdGUgaW4yPSJoYXJkQWxwaGEiIG9wZXJhdG9yPSJvdXQiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMjUgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvd18yNTg2XzM1MzQwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9kcm9wU2hhZG93XzI1ODZfMzUzNDAiIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+";